import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/book/$workId/edition/$editionId')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/work/$workId/edition/$editionId',
            params,
            replace: true,
        })
    },
})
